import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { IMG } from "../../data/assets";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const WeddingsTeaser = () => {
  const { t } = useLanguage();
  const flow = t("wflow.chips");

  return (
    <section id="weddings-teaser" data-testid="weddings-teaser" className="relative py-8 md:py-12 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={IMG.weddingHero} alt="Mediterranean wedding reception" className="photo-grade w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#14180E]/80" />
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-5 md:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="max-w-3xl">
          <p className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-6">{t("teaser.eyebrow")}</p>
          <h2 className="font-display font-light tracking-tight leading-[1.03] text-4xl sm:text-5xl md:text-6xl text-[--text]">
            {t("teaser.h2a")} <span className="italic text-[--gold]">{t("teaser.h2b")}</span>
          </h2>
          <p className="mt-6 text-[--text-2] text-base md:text-lg leading-relaxed">
            {t("teaser.p1")}
          </p>
          <p className="mt-6 text-[--text] text-base leading-relaxed max-w-2xl">
            {t("teaser.p2")}
          </p>

          <div className="flex flex-wrap items-center gap-2 mt-8">
            {flow.map((step, i) => (
              <div key={i} className="flex items-center gap-2">
                <span className="px-4 py-2 rounded-full border border-[--gold]/50 text-[--gold] font-mono text-[10px] uppercase tracking-[0.15em]">{step}</span>
                {i < flow.length - 1 && <span className="text-[--gold]/50">→</span>}
              </div>
            ))}
          </div>

          <Link to="/weddings" data-testid="teaser-weddings-btn" className="mt-10 inline-flex items-center justify-center px-8 py-4 rounded-full bg-[--gold] text-[#14180E] font-mono text-[11px] uppercase tracking-[0.16em] hover:bg-[--text] transition-colors duration-400">
            {t("teaser.btn")}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
